var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutstanding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UX-82-Therapy-Status-Isolated",
    transform: "translate(-535.000000, -646.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(531.000000, 641.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    fill: "#E0BB53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 6.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55766933,9.82865283 C2.73559415,14.4175824 6.49425604,18.1111111 11.1203014,18.1111111 C13.8114144,18.1111111 16.2801213,16.8799349 17.9259259,14.7309727 L16.4580461,13.2535613 L16.4358055,13.2983313 C15.2125724,15.021978 13.2331587,16.0516891 11.1203014,16.0516891 C7.65076739,16.0516891 4.78172962,13.2983313 4.6038048,9.82865283 L5.71583494,10.9479039 L7.16147413,9.49287749 L3.58073706,5.88888889 L0,9.49287749 L1.44563919,10.9479039 L2.55766933,9.82865283 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4423307,8.28245828 C19.2644058,3.69352869 15.505744,0 10.8796986,0 C8.18858561,0 5.71987869,1.23117623 4.07407407,3.38013838 L5.54195386,4.85754986 L5.56419447,4.81277981 C6.78742763,3.08913309 8.76684128,2.05942206 10.8796986,2.05942206 C14.3492326,2.05942206 17.2182704,4.81277981 17.3961952,8.28245828 L16.2841651,7.16320716 L14.8385259,8.61823362 L18.4192629,12.2222222 L22,8.61823362 L20.5543608,7.16320716 L19.4423307,8.28245828 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstanding);
export default __webpack_public_path__ + "static/media/Outstanding.e1ce8834e68e5f4395559ff877971479.svg";
export { ForwardRef as ReactComponent };